module.exports = __webpack_public_path__ + "static/young-leader-photo-emily_cheston-86b41c6bcaf6e0ac809f65cadc9cb889.jpg";